// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__PcIQo","head":"styles_head__3GuPB","title":"styles_title___P6j0","content":"styles_content__3Z_e6","pagination":"styles_pagination__oHTfS"};